module.exports = __webpack_public_path__ + "img/h_product_2.2bf9364.jpg";